/**
 * @license
 * @copyright Copyright Motili Inc., 2023 All Rights Reserved
 */

import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import {
    resetState,
    setStatus,
} from '../../../common/redux/ducks/contractorRegistrationForm';
import { useAppDispatch, useAppSelector } from '../../../common/redux/hooks';
import { postContractorToDocumentDb } from '../../../common/services/documentdb';
import Documents from './Documents';
import { defaultTradeType } from '../../../common/constants';

export default function DocumentsPage() {
    const dispatch = useAppDispatch();
    const navigate = useNavigate();
    const { contractor, starterInfo, UUID, status, signatureId } =
        useAppSelector(({ contractorRegistration }) => contractorRegistration);

    const { registerForLaborJobs, trades } = contractor;

    const [busy, setBusy] = useState(false);

    // set a default trade type for non-labor based contractors
    // (product ask because these fields are required for contractor company registration in s2)
    const handleTradeType = !registerForLaborJobs ? defaultTradeType : trades;

    const handleBackClick = () => {
        const route = registerForLaborJobs
            ? '/contractor/laborInfo'
            : '/contractor/company';
        navigate(route);
    };

    const handleNextClick = () => {
        if (status === 'PENDING') {
            navigate('/contractor/welcome');
        } else {
            const _contractor = {
                ...contractor,
                trades: handleTradeType,
            };
            setBusy(true);
            postContractorToDocumentDb(
                signatureId,
                starterInfo,
                _contractor,
                UUID
            )
                .then(() => {
                    dispatch(setStatus('PENDING'));
                    dispatch(resetState());
                    navigate('/contractor/complete');
                    setBusy(false);
                })
                .catch(error => {
                    setBusy(false);
                    alert(error);
                });
        }
    };
    const handleUploadNavigationClick =
        (fileName: string, label: string) => () => {
            navigate(`/contractor/upload/${fileName}/${label}`);
        };

    return (
        <Documents
            handleBackClick={handleBackClick}
            handleNextClick={handleNextClick}
            handleUploadNavigationClick={handleUploadNavigationClick}
            busy={busy}
        />
    );
}

